// Canonical URL builders for the 3D board editor, which lives at /board/:id.
// The legacy /project/:id prefix redirects here permanently (~500k external
// links reference it), so pathname checks must accept both prefixes.

export const newBoardFromPath = (sourceId: string) =>
  `/board/new_from?id=${sourceId}`;

// Matches the editor at either prefix. The trailing slash matters: the /boards
// marketing page (StudioXRHome) must never match.
export const isBoardEditorPath = (pathname: string) =>
  pathname.startsWith("/board/") || pathname.startsWith("/project/");
